import { lazy } from "react";

export const AuthPage = lazy(() => import("../Pages/Auth/Auth.layout"));

export const PhoneForm = lazy(
  () => import("../Pages/Auth/Components/PhoneForm.component")
);

export const VerifyForm = lazy(
  () => import("../Pages/Auth/Components/VerifyForm.component")
);

export const BankList = lazy(
  () => import("../Pages/User/Bank/BankList/BankList.page")
);

export const CreateBankAccount = lazy(
  () => import("../Pages/User/Bank/CreateBankAccount/CreateBankAccount")
);

export const CreateGateway = lazy(
  () => import("../Pages/User/Gateway/CreateGateway/CreateGateway")
);

export const GatewayList = lazy(
  () => import("../Pages/User/Gateway/GatewayList/GatewayList")
);

export const GatewaySetting = lazy(
  () => import("../Pages/User/Gateway/Component/GatewaySetting/GatewaySetting")
);

export const TicketListPage = lazy(
  () => import("../Pages/User/Ticket/TicketList/TicketList.page")
);

export const UserEditPage = lazy(
  () => import("../Pages/User/User/UserEdit/UserEdit.page")
);

export const AddressList = lazy(
  () => import("../Pages/User/Address/AddressList/AddressList.page")
);

export const CreateAddress = lazy(
  () => import("../Pages/User/Address/CreateAddress/CreateAddress")
);

export const Document = lazy(() => import("../Pages/User/Document/Document"));

export const TransactionList = lazy(
  () => import("../Pages/User/Transaction/TransactionList/TransactionList.page")
);

export const TransactionDescription = lazy(
  () =>
    import(
      "../Pages/User/Transaction/TransactionDescription/TransactionDescription"
    )
);

export const UserAgentPage = lazy(
  () => import("../Pages/User/UserAgents/UserAgent.page")
);

export const DashboardLayout = lazy(
  () => import("../Components/Layouts/DashboardLayout/Dashboard.layout")
);

export const GatewayForm = lazy(
  () =>
    import(
      "../Pages/User/Gateway/Component/GatewaySetting/Components/UpdateForm/Gateway.form"
    )
);

export const ShaparakRequest = lazy(
  () =>
    import(
      "./../Pages/User/Gateway/Component/GatewaySetting/Components/ShaparakRequest/ShaparakRequest"
    )
);

export const ShaparakList = lazy(
  () =>
    import(
      "../Pages/User/Gateway/Component/GatewaySetting/Components/ShaparakWaitingList/ShaparakWaitingList"
    )
);

export const ShaparakAcceptedList = lazy(
  () =>
    import(
      "../Pages/User/Gateway/Component/GatewaySetting/Components/ShaparakAcceptedList/ShaparakAcceptedList"
    )
);

export const RequestList = lazy(
  () =>
    import(
      "../Pages/User/Gateway/Component/GatewaySetting/Components/RequestList/RequestList"
    )
);

export const ShaparakAcceptedInfo = lazy(
  () =>
    import(
      "../Pages/User/Gateway/Component/GatewaySetting/Components/ShaparakAcceptedList/ShaparakAcceptedInfo/ShaparakAcceptedInfo"
    )
);

export const Marketing = lazy(
  () => import("../Pages/User/Marketing/Marketing.page")
);

export const Wallet = lazy(
  () => import("../Pages/User/Wallet/WalletList/WalletList.page")
);

export const WalletTransactionList = lazy(
  () =>
    import(
      "../Pages/User/Wallet/Component/WalletTransactionList/WalletTransactionList.page"
    )
);

export const SubsetTransactionList = lazy(
  () =>
    import(
      "../Pages/User/Marketing/Components/MarketingSubset/Components/SubsetTurnover.page"
    )
);

export const AdminsActivityPage = lazy(
  () => import("../Pages/Admins/AdminsActivities/AdminsActivitesList.page")
);

export const SandboxTransactinons = lazy(
  () =>
    import(
      "../Pages/User/Gateway/Component/SanboxTransaction/SandboxTransactinons"
    )
);

export const WithdrawList = lazy(
  () => import("../Pages/User/Withdraw/WithdrawList/WithdrawList.page")
);

export const WithdrawInfo = lazy(
  () => import("../Pages/User/Withdraw/WithdrawInfo/WithdrawInfo.page")
);

export const GatewayNotifications = lazy(
  () =>
    import(
      "./../Pages/User/Gateway/Component/GatewaySetting/Components/GatewayNotifications/GatewayNotifications.page"
    )
);

export const UserNotification = lazy(
  () => import("../Pages/User/UserNotifications/UserNotifications")
);

export const GatewayAdminList = lazy(
  () =>
    import("../Pages/User/Gateway/Component/GatewayAdmins/GatewayAdminsList")
);

export const UserList = lazy(
  () => import("../Pages/User/User/UserList/UserList.page")
);

export const UserTransactionList = lazy(
  () => import("../Pages/User/User/UserTransactionList/UserTransactionList")
);

export const AdminList = lazy(
  () => import("../Pages/Admins/AdminList/AdminList.page")
);

export const UserInfoFormFields = lazy(
  () =>
    import(
      "../Pages/User/User/UserEdit/Components/UserMiddleSection/UserFields/User.form"
    )
);

export const AdminForm = lazy(
  () => import("../Pages/Admins/AdminForm/Admin.Form")
);

export const NewsList = lazy(
  () => import("../Pages/News/NewsList/NewsList.page")
);

export const NewsForm = lazy(() => import("../Pages/News/NewsForm/News.Form"));

export const EventList = lazy(
  () => import("../Pages/StatusAqa/Events/EventList/EventList.page")
);

export const EventForm = lazy(
  () => import("../Pages/StatusAqa/Events/EventForm/Event.Form")
);

export const PanelMain = lazy(
  () => import("../Pages/Dashboard/PanelMain/PanelMain")
);

export const ServiceList = lazy(
  () => import("../Pages/StatusAqa/Services/ServicesList/ServiceList.page")
);

export const TicketItem = lazy(
  () =>
    import("../Pages/User/Ticket/TicketPage/Components/TicketItem/TicketItem")
);

export const UserListInventory = lazy(
  () => import("../Pages/User/User/UserList/Components/UserListInventory.page")
);

export const PartnerList = lazy(
  () => import("../Pages/Partner/PartnerList/PartnerList.page")
);

export const TicketOperatorListPage = lazy(
  () => import("../Pages/Reports/TicketOperator/TicketOperatorList.page")
);

export const TicketConversationPage = lazy(
  () => import("../Pages/Reports/TicketConversation/TicketConversation.page")
);
